import { Inject, Injectable } from '@angular/core';
import {mbeConfigService} from './mbe-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeeSourceInterface } from '../..';


@Injectable({
  providedIn: 'root'
})
export class FeeSourceService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(mbeConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllFeeSource(): Observable<FeeSourceInterface[]> {
    const headers = this.headers;
    return this.httpClient.get<FeeSourceInterface[]>(`${this.URL}/fso/allfeesource`, {headers});
  }
}

